export default "__VITE_ASSET__1bb1d15e__"